import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../InitialPage/Sidebar/Header";
import Sidebar from "../InitialPage/Sidebar/Sidebar";
import ThemeSettings from "../InitialPage/themeSettings";
import { useDispatch, useSelector } from "react-redux";
import { getCookie } from "../feature-module/common/common";
import { setUserData, setUserPermission } from "../core/redux/action";
import { privateRoutes, posRoutes, pagesRoute } from "./router.link";
import LoadingSpinner from "../InitialPage/Sidebar/LoadingSpinner";
import apiHandler from "../feature-module/common/api";
import { all_routes } from "./all_routes";

const route = all_routes;

const Layout = ({ type }) => {
  const data = useSelector((state) => state.toggle_header);
  //  const userData = useSelector((state) => state.user_data);
  //    const navigate = useNavigate();
//   useEffect(() => {
// userData.token == "" || userData.token == undefined 
// navigate(route.signin);
//   },[])
  if (type === "pos") {
    return (
      <div>
        <Header />
        <Outlet />
        <ThemeSettings />
      </div>
    );
  } else if (type === "auth") {
    return (
      <div className={data ? "header-collapse" : ""}>
        <Outlet />
        <ThemeSettings />
      </div>
    );
  } else {
    // main
    return (
      <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
        <Header />
        <Sidebar />
        <Outlet />
        <ThemeSettings />
      </div>
    );
  }
};
const ProtectedRoute = ({ isLoggedIn, children }) => {
  const location = useLocation(); // Get the current route path
  const userData = useSelector((state) => state.user_data);
  const userPermissions = useSelector((state) => state.userpermission); // User permissions

  console.log(userData, "userData54545456")
  console.log(isLoggedIn, "location.pathname");
  if (isLoggedIn === null) {
    return <LoadingSpinner isLoading={true} />;
  } else if (!isLoggedIn) {
    return <Navigate to={route.signin} />;
  } else if (userPermissions.length === 0) {
    return <LoadingSpinner isLoading={true} />;
  }

  // Allow all routes for admin (roleID === 1)
  if (userData?.roleID === 1) {
    return children;
  }

  // Extract allowed paths from user permissions
  const allowedRoutes = new Set(
    userPermissions.map((perm) => perm.permissionKey)
  );
  console.log(allowedRoutes, "456123",userPermissions);

  // Function to check if the path matches a dynamic route
  const isAllowed = [...allowedRoutes].some((allowedRoute) => {
    if (location.pathname === allowedRoute) {
      return true; // Exact match
    }
    // Check for dynamic routes like "/AddCategorys/23"
    const regex = new RegExp(`^${allowedRoute}/[0-9]+$`); // Allows numeric IDs
    return regex.test(location.pathname);
  });


  console.log(isAllowed,location.pathname,"7532159");
  

  // Ensure dashboard is always accessible
  if (!isAllowed && location.pathname !== "/dashboard" && location.pathname !== "/") {
    return <Navigate to={route.error404} />;
  }

  return children;
};

const AllRoutes = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user_data);
  const [isLoggedIn, setIsLoggedIn] = useState(null); // Null for initialization state
  const [isPermissionsLoaded, setIsPermissionsLoaded] = useState(false); // Track permissions loading state

  const getUserPermissionApi = async (uData) => {
    try {
      console.log(uData,"78545454");
      
      
      setIsPermissionsLoaded(true);
      await apiHandler({
        method: "GET",
        route: "auth/getuserpermission",
        payload: { userId: uData?.id || 0 },
      })
        .then((response) => {
           console.log(response, "userpermission");
          dispatch(setUserPermission(response.ResponseData));
          setIsPermissionsLoaded(false); // Set permissions as loaded
        })
        .catch((error) => {
          console.error(error);
          setIsPermissionsLoaded(false); // If error occurs, still allow access
        });
    } catch (error) {
      console.log(error,"8798798/");
      
    }
  };

  useEffect(() => {
    const userCookieData = getCookie("u");
    const finalData = userCookieData ? JSON.parse(userCookieData) : null;
    const isLoggedInCookie = finalData?.isLoggedIn || false;

    setIsLoggedIn(isLoggedInCookie);
    if (finalData) {
      dispatch(setUserData(finalData));
      // getUserPermissionApi(finalData);
    }
  }, [dispatch]);

  useEffect(() => {
    if (userData?.isLoggedIn) {
       // console.log(userData, "78545454");
      setIsLoggedIn(userData?.isLoggedIn);
      getUserPermissionApi(userData);
    }
  }, [userData]);

  console.log(isLoggedIn, "isLoggedIn");


  // Only render routes once permissions are loaded
  // if (!isPermissionsLoaded) {
  //   if(isLoggedIn){
  //     return <LoadingSpinner isLoading={true} />;
  //   }
  // }

  return (
    <>
      <LoadingSpinner isLoading={isPermissionsLoaded} />
      <Routes>
        {/* POS Routes */}
        <Route
          path="/pos"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Layout type="pos" />
            </ProtectedRoute>
          }
        >
          {posRoutes.map((route) => (
            <Route key={route.id} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Private Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute isLoggedIn={isLoggedIn}>
              <Layout type="main" />
            </ProtectedRoute>
          }
        >
          {privateRoutes.map((route) => (
            <Route key={route.id} path={route.path} element={route.element} />
          ))}
        </Route>

        {/* Public Routes */}
        <Route path="/" element={<Layout type="auth" />}>
          {pagesRoute.map((route) => (
            <Route key={route.id} path={route.path} element={route.element} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default AllRoutes;
